export default __webpack_public_path__ + "static/media/965.47ef9d84.png";